const CallDetailsQuery = {
  query: {
    index: 'iris-platform-logs-*',
    preference: '_primary_first',
    scroll: '5m',
    body: {
      size: 10000,
      _source: {
        excludes: [],
      },
      aggs: {
        traceIds: {
          terms: {
            field: 'traceId.keyword',
            size: 5000,
            order: {
              _term: 'desc',
            },
          },
          aggs: {
            milestones: {
              terms: {
                field: 'milestone.keyword',
                size: 50,
                order: {
                  _term: 'desc',
                },
              },
              aggs: {
                timestamp: {
                  terms: {
                    field: '@timestamp',
                    size: 5,
                    order: {
                      _term: 'desc',
                    },
                  },
                  aggs: {
                    srcTN: {
                      terms: {
                        field: 'srcTN.keyword',
                        size: 5,
                        order: {
                          _term: 'desc',
                        },
                        missing: '__missing__',
                      },
                      aggs: {
                        dstTN: {
                          terms: {
                            field: 'dstTN.keyword',
                            size: 5,
                            order: {
                              _term: 'desc',
                            },
                            missing: '__missing__',
                          },
                        },
                      },
                    },
                  },
                },
              },
            },
          },
        },
      },
      stored_fields: [
        '*',
      ],
      script_fields: {},
      docvalue_fields: [
        '@timestamp',
        'subscriberRecord.updatedAt',
        'timestamp',
        'wssPayload.timeseries.General.timestamp',
        'wssPayload.timestamp',
      ],
      query: {
        bool: {
          must: [
            {
              query_string: {
                query: `traceId.keyword: (###traceListPlaceholder###)
                        AND (type.keyword: event_manager
                        OR type.keyword: notification_manager
                        OR type.keyword: sip_proxy)
                        AND milestone exists`,
                analyze_wildcard: true,
                default_field: '*',
              },
            },
            {
              range: {
                '@timestamp': {
                  gte: 1559235211091,
                  lte: 1559840011091,
                  format: 'epoch_millis',
                },
              },
            },
          ],
          filter: [],
          should: [],
          must_not: [],
        },
      },
    },
  },
};

const NtmDetailsQuery = {
  query: {
    index: 'iris-platform-logs-*',
    preference: '_primary_first',
    scroll: '5m',
    body: {
      query: {
        bool: {
          must: [
            {
              query_string: {
                default_field: '*',
                query: 'type.keyword: notification_manager AND traceId.keyword: ###traceListPlaceholder###',
              },
            },
            {
              range: {
                '@timestamp': {
                  gte: 'now-4h',
                  lte: 'now',
                },
              },
            },
          ],
        },
      },
      size: 10000,
      _source: ['traceId', 'code', '@timestamp', 'Message', 'message'],
      sort: [
        {
          '@timestamp': {
            order: 'desc',
          },
        },
      ],
    },
  },
};

// const TestQuery = {
//   query: {
//     index: 'iris-platform-logs-*',
//     preference: '_primary_first',
//     scroll: '5m',
//     body: {
//       query: {
//         bool: {
//           must: [
//             {
//               query_string: {
//                 query: `traceId.keyword: ("269bb840-8700-11e9-9290-01f0768447ab",
//                         "0wnd3uftczczd0ftetnxefvv00dyxyky@ATS.tasatl1.ssg.comcast.net.100")
//                         AND (type.keyword: event_manager OR type.keyword: notification_manager
//                         OR type.keyword: sip_proxy)  AND milestone exists`,
//                 analyze_wildcard: true,
//                 default_field: '*',
//               },
//             },
//             {
//               range: {
//                 '@timestamp': {
//                   gte: '1559584804355',
//                   lte: '1560189604355',
//                   format: 'epoch_millis',
//                 },
//               },
//             },
//           ],
//           filter: [],
//           should: [],
//           must_not: [],
//         },
//       },
//       size: 10000,
//       _source: [
//         'traceId',
//         'n',
//         'routingId',
//         'eventType',
//         '@timestamp',
//         'meta.*',
//         'attr.*',
//         'type',
//         'appDomain',
//         'event',
//         'Module',
//         'eventMessage',
//         'SIP_peer_state',
//         'evmEventType',
//         'member_role',
//         'media',
//         'sipEvent',
//         'callType',
//         'rxAudio.bytesReceived',
//         'txAudio.bytesSent',
//         'Bytes-Received',
//         'Bytes-Sent',
//         'sipCode',
//         'OKCseq',
//         'srcTN',
//         'dstTN',
//         'wssPayload.timeseries.groups',
//         'wssPayload.timeseries.rxAudio.bytesReceived',
//         'wssPayload.timeseries.txAudio.bytesSent',
//         'sipC',
//         'responseHeaders.CSeq',
//         'wssPayload.callsummary.callDuration',
//         'wssPayload.callsummary.callStatus',
//         'wssPayload.callsummary.callFailureReason',
//         'wssPayload.meta.sdkType',
//         'wssPayload.meta.sdkVersion',
//       ],
//       sort: [
//         {
//           '@timestamp': {
//             order: 'desc',
//             unmapped_type: 'boolean',
//           },
//         },
//       ],
//     },
//   },
// };

export default { CallDetailsQuery, NtmDetailsQuery };
